/*
  clikt. — product gallery: preload every image so switching is instant.

  The frame itself is a plain fixed window sized in CSS (clikt.css) — no
  resizing here. This file does one thing: after the page is interactive it
  quietly pulls every gallery image into cache. Dawn lazy-loads all but the
  first and hides the inactive slides with display:none, so without this the
  frame blanks for a beat while the next image downloads. Preloaded, the swap
  is instant. First paint stays fast because this runs after load.
*/
(function () {
  'use strict';

  function preloadGallery() {
    var imgs = document.querySelectorAll('.product__media-wrapper .product__media-list img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      im.setAttribute('loading', 'eager');
      if (im.complete) continue;
      var src = im.currentSrc || im.getAttribute('src');
      if (!src) continue;
      var pre = new Image();
      if (im.getAttribute('sizes')) pre.sizes = im.getAttribute('sizes');
      if (im.getAttribute('srcset')) pre.srcset = im.getAttribute('srcset');
      pre.src = src;
    }
  }

  if (document.readyState === 'complete') preloadGallery();
  else window.addEventListener('load', preloadGallery);
})();
